var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"extra"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"copyright"},[_c('p',[_vm._v(" 备案号："),_c('a',{attrs:{"href":"https://beian.miit.gov.cn/"}},[_vm._v("苏ICP备2021057232号")])])])])])
}]

export { render, staticRenderFns }